import { Input } from 'antd';
import get from 'lodash/get';

import Button from '~/shared/components/form-fields/button';
import type { ButtonType, FormFieldType } from '~/shared/types/form-type';

export type PatternP3PropsType = {
  submitting: boolean;
  textAlign: string;
  field: string;
  position1: {
    formFields: FormFieldType[];
  };
  position2: {
    formFields: FormFieldType[];
  };
  position3: {
    formFields: FormFieldType[];
  };
  position4: {
    formFields: FormFieldType[];
  };
  position5: {
    buttons: ButtonType[];
  };
  t: (key: string, options: { ns: string[] }) => string;
  getFieldProps: (name: string) => void;
};

export const PatternP3 = ({
  submitting,
  position3,
  position2,
  position4,
  position1,
  position5,
  getFieldProps,
  field,
}: PatternP3PropsType) => (
  <div className="pattern-p3">
    <div>
      {position1 && (
        <div className="pattern-p3__position-block">
          {get(position1, 'formFields', []).map((item) => {
            const Field = Input;

            return (
              <div className="pattern-p3__form-field-block" key={item.name}>
                <div className="pattern-p3__label">{item.label}</div>
                <Field
                  name={field ? `${field}.${item.name}` : item.name}
                  type={item.type}
                  label={item.label}
                  {...item.config}
                  validate={(a) => item.validate(a).filter((error) => error !== null)[0]}
                  {...getFieldProps(field ? `${field}.${item.name}` : item.name)}
                >
                  {Input}
                </Field>
              </div>
            );
          })}
          {get(position1, 'buttons', []).map((item, index) => (
            <Button
              key={index}
              className="extra-small invert"
              onClick={(e) => {
                e.preventDefault();
              }}
            >
              {item.buttonName}
            </Button>
          ))}
        </div>
      )}
      <div>
        {position2 && (
          <div className="pattern-p3__position-block">
            {get(position2, 'formFields', []).map((item) => {
              const Field = Input;

              return (
                <div className="pattern-p3__form-field-block" key={item.name}>
                  <div className="pattern-p3__label">{item.label}</div>
                  <Field
                    name={field ? `${field}.${item.name}` : item.name}
                    type={item.type}
                    label={item.label}
                    {...item.config}
                    validate={(a) => item.validate && item.validate(a).filter((error) => error !== null)[0]}
                    {...getFieldProps(field ? `${field}.${item.name}` : item.name)}
                  >
                    {Input}
                  </Field>
                </div>
              );
            })}
            {get(position2, 'buttons', []).map((item, index) => (
              <Button
                key={index}
                className="extra-small invert"
                onClick={(e) => {
                  e.preventDefault();
                }}
              >
                {item.buttonName}
              </Button>
            ))}
          </div>
        )}
        {position3 && (
          <div className="pattern-p3__position-block">
            {get(position3, 'formFields', []).map((item) => {
              const Field = Input;

              return (
                <div className="pattern-p3__form-field-block" key={item.name}>
                  <div className="pattern-p3__label">{item.label}</div>
                  <Field
                    name={field ? `${field}.${item.name}` : item.name}
                    type={item.type}
                    label={item.label}
                    {...item.config}
                    validate={(a) => item.validate && item.validate(a).filter((error) => error !== null)[0]}
                    {...getFieldProps(field ? `${field}.${item.name}` : item.name)}
                  >
                    {Input}
                  </Field>
                </div>
              );
            })}
            {get(position3, 'buttons', []).map((item, index) => (
              <Button
                key={index}
                className="extra-small invert"
                onClick={(e) => {
                  e.preventDefault();
                }}
              >
                {item.buttonName}
              </Button>
            ))}
          </div>
        )}
      </div>
    </div>
    {position4 && (
      <div className="pattern-p3__position-block">
        {get(position4, 'formFields', []).map((item) => {
          const Field = Input;

          return (
            <div className="pattern-p3__form-field-block" key={item.name}>
              <div className="pattern-p3__label">{item.label}</div>
              <Field
                name={field ? `${field}.${item.name}` : item.name}
                type={item.type}
                label={item.label}
                {...item.config}
                validate={(a) =>
                  item.validate && item.validate(a === undefined ? '' : a).filter((error) => error !== null)[0]
                }
                {...getFieldProps(field ? `${field}.${item.name}` : item.name)}
              >
                {Input}
              </Field>
            </div>
          );
        })}
        {get(position4, 'buttons', []).map((item, index) => (
          <Button
            key={index}
            className="extra-small invert"
            onClick={(e) => {
              e.preventDefault();
            }}
          >
            {item.buttonName}
          </Button>
        ))}
      </div>
    )}
    {position5 && (
      <div className="pattern-p3__form-field-block">
        {get(position5, 'buttons', []).map((item, index) => (
          <Button
            key={index}
            className="extra-small invert"
            onClick={(e) => {
              e.preventDefault();
            }}
          >
            {item.buttonName}
          </Button>
        ))}
      </div>
    )}
  </div>
);
